import React, { useEffect, useState } from "react";
import { Table, Offcanvas } from "react-bootstrap";
import Moment from "react-moment";
import { useParams } from "react-router";
import { studyOnboardingService } from "../../../../../APIServices/studyOnboarding";
import Pagination from "../../../../Pagination";
import { PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
const ViewSubjectActivity = ({
  tableRef,
  onMouseDown,
  Show,
  Hide,
  Title,
  subjectId,
}) => {
  let { studyId } = useParams();
  const [siteActivityCount, setSiteActivityCount] = useState(0);
  const [siteActivity, setSiteActivity] = useState([]);
  const [activityLoader, setActivityLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "subjectData",
      studyId,
      subjectId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setSiteActivity(data?.data || []);
    setSiteActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(siteActivityCount / itemsPerPage);

  useEffect(() => {
    if(subjectId){
      getStudyAuditTrials(pageNumber, itemsPerPage);
    }
  }, [pageNumber, itemsPerPage, subjectId]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{width : 900}}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {activityLoader ? (
            <PageLoader/>
          ) : (
            <>
              <Table
                ref={tableRef}
                className="m-0 custom-table"
                hover
                striped
              >
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th
                      style={{ width: 100 }}
                      onMouseDown={(e) => onMouseDown(e, 1)}
                    >
                      Activity Type
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Activities</th>
                    <th
                      style={{ width: 200 }}
                      onMouseDown={(e) => onMouseDown(e, 3)}
                    >
                      Previous Value
                    </th>
                    <th
                      style={{ width: 200 }}
                      onMouseDown={(e) => onMouseDown(e, 4)}
                    >
                      Updated Value
                    </th>
                    <th
                      style={{ width: 100 }}
                      onMouseDown={(e) => onMouseDown(e, 5)}
                    >
                      Activity By
                    </th>
                    <th
                      style={{ width: 130 }}
                      onMouseDown={(e) => onMouseDown(e, 6)}
                    >
                      Activity Date | Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {siteActivity?.map((item, index) => (
                    <tr>
                      <td className="text-center">
                        {index + 1 + startIndex}.
                      </td>
                      <td className="text-uppercase">{item?.actionType}</td>
                      <td>{item?.activities}</td>
                      <td>{item?.previousValue}</td>
                      <td>{item?.updatedValue}</td>
                      <td>{item?.activityBy}</td>
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {item.createdAt}
                        </Moment>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={siteActivityCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ViewSubjectActivity;
